export default __webpack_public_path__ + "static/media/m.78d60094.mp4";